import e from "react";
import i from "./kioskTitle.module.scss.js";
function s({ text: t }) {
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "kiosk-title", className: i.kioskTitle }, t);
}
export {
  s as KioskTitle
};
//# sourceMappingURL=KioskTitle.js.map
